import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up-right",
  "use": "arrow-up-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-up-right\">\n<path d=\"M7,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l10-10c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-10,10C7.5,17.9,7.3,18,7,18z\" />\n<path d=\"M17,18c-0.6,0-1-0.4-1-1V8H7C6.4,8,6,7.6,6,7s0.4-1,1-1h10c0.6,0,1,0.4,1,1v10C18,17.6,17.6,18,17,18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol